/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from './store'
// import firebase from "firebase";
// import 'firebase/auth'
// let firebaseConfig = {
//   apiKey: "AIzaSyBnqNRGHSVKVqdj98wjQT3eG6UTmdOwnVc",
//   authDomain: "stichh-81881.firebaseapp.com",
//   projectId: "stichh-81881",
//   storageBucket: "stichh-81881.appspot.com",
//   messagingSenderId: "743182157976",
//   appId: "1:743182157976:web:9d02fd42cbfe43e40ca8ed",
//   measurementId: "G-BCCQKCF3VW"
// }
// firebase.initializeApp(firebaseConfig);
Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
